//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractRoomContentNavModel, AbstractRoomContentModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";


@PresenterRegistration({
  types: [AbstractRoomContentNavModel]
})
@Component({
  selector: "room-content-nav-item",
  standalone: false,
  templateUrl: "./room-content-nav-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomContentNavItemComponent<TRoom extends AbstractRoomContentModel> {
  public data: WritableSignal<AbstractRoomContentNavModel<TRoom>> = signal<AbstractRoomContentNavModel<TRoom>>(null);

  public isActive = computed(() => {
    return this.data().items().some(item => item.isChecked());
  });
}
